<template>
    <li class="choice u-bg--white" @click="setInputActive" :class="{active: inputActive}">
      <label :for="idBtn">
        <div class="choice-content">

          <div @click="showModal" class="img" v-if="answer.node.imageUrl">
            <img :src="imgPath">
            <span class="loupe"></span>
          </div>
          <modal-image  v-show="isModalVisible"
                        @close="closeModal"
                        :image="answer.node.imageUrl"
          />

          <choice-button v-if="type=='radio' || type=='checkbox'"
                        :idBtn="idBtn"
                        :value="idBtn"
                        :type="type"
                        :checked="checkButton"
          />

          <!-- Si le type est un radio ou checkbox -->
          <div class="label radio checkbox" v-if="type === 'radio' || type === 'checkbox'">
            <span class="description"></span>
            <div>
              <h3>{{answer.node.title}}</h3>
              <div class="body" v-if="answer.node.body" v-html="answer.node.body"></div>
              <link-info  v-if="answer.node.seeMoreContent" :text="'Information complémentaire'" :nameLink="'En savoir plus'" :href="'/info/' + content.slug" class="link-eval u-color--blue"/>

            </div>
          </div>

          <!-- si le type est un input -->
          <div class="label laurange" v-else>
            <div class="input">
              <input v-if="typeOptions.type === 'range' " id="value" type="number" v-model="valueInput">

              <input :type="typeOptions.type"
                     :class="typeOptions.class"
                     :min="typeOptions.min"
                     :max="typeOptions.max"
                     v-model.lazy="valueInput"
              />
            </div>

            <div>
              <h3>{{answer.node.title}}</h3>
              <div class="body"  v-if="answer.node.body" v-html="answer.node.body"></div>
              <link-info  v-if="answer.node.seeMoreContent" :text="'Information complémentaire'" :nameLink="'En savoir plus'" :href="'/info/' + content.slug" class="link-eval u-color--blue"/>
            </div>

          </div>

        </div>
      </label>
    </li>
</template>

<script>
  import ChoiceButton from './Granular/ChoiceButton'
  import ModalImage from "./../../../Modal/Models/Modal-image"
  import { mapActions, mapGetters } from 'vuex'
  import LinkInfo from "../../../Core/Link/LinkInfo";
  import gql from 'graphql-tag'

  export default {
    name: "Choice",
    props: ['idBtn', 'type', 'answer', 'answerSelected'],
    data: () => {
      return {
        isModalVisible: false,
        content: '',
        val: 0,
        inputActive: false
      }
    },
    components: {
      LinkInfo,
      ChoiceButton,
      ModalImage
    },
    computed: {
      ...mapGetters({
        minimalAnswerSelected: 'getAnswerSelected'
      }),
      valueInput: {
        get: function(val) {
          if (typeof this.minimalAnswerSelected['answer_' + this.idBtn] !== 'undefined') {

            return this.minimalAnswerSelected['answer_' + this.idBtn]
          }

          return this.val
        },
        set: function(val) {
          this.val = val

          let answers = this.minimalAnswerSelected

          if (!answers || answers === 'false') {
            answers = {}
          }

          this.$set(answers, 'answer_' + this.idBtn, val)

          this.setAnswerSelected(answers)
        }
      },
      checkButton() {
        let test = false

        if (typeof this.answerSelected !== 'undefined') {
          this.answerSelected.map(answer => {
            if (answer.node._id == this.idBtn) {
              test = true
            }
          })
        }

        return test
      },
      imgPath() {
        if (this.answer.node.imageUrl) {
          if (this.answer.node.imageUrl.startsWith('https') || this.answer.node.imageUrl.startsWith('//')) {
            return this.answer.node.imageUrl;
          } else {
            return process.env.VUE_APP_URL_UPLOADS + this.answer.node.imageUrl;
          }
        } else {
          return '';
        }
      },
      typeOptions() {
        if (this.type === 'input') {
          return JSON.parse(this.answer.node.typeOptions)
        }
      },
    },
    methods: {
      setInputActive() {
        this.inputActive = !this.inputActive
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      ...mapActions({
        setAnswerSelected: 'setAnswerSelected',
      }),
      getContentSlug(idAnswer) {
        const contentQuery = gql`query content($id: ID) {
          content(id: $id) {
            slug
          }
        }`

        this.$apollo.query({
          query: contentQuery,
          variables: {
            id: 'api/v1/contents/' + idAnswer
          }
        }).then( result => {
          this.content = result.data.content ? result.data.content : false
        })
      }
    },
    watch: {
      answer: {
        handler: function(val) {
          if(val.node.seeMoreContent) {
            this.getContentSlug(val.node.seeMoreContent._id)
          }
        },
        immediate: true
      }
    },
    updated() {
      let choice = this.$el

      if(typeof this.answerSelected !== 'undefined') {
        var elems = document.querySelector(".active");
        if(elems !==null){
          elems.classList.remove("active");
        }

        choice.addEventListener("click", (e) => {
          choice.classList.add('active');

        });
      }
    }

  }
</script>

<style lang="scss">
  li.choice {
    border: 1px solid transparent;
    border-top: 1px solid color(border);
    list-style-type: none;

    &:hover, &.active {
      background-color: color(blue-soft);
      cursor: pointer;
      border: 1px solid color(blue-border);
    }

    &:last-child {
      border-bottom: 1px solid color(border);
    }

    .choice-content {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: left;
      padding: rem(28px) rem(20px) rem(26px);

      @include mq($until: MD) {
        padding: rem(26px) rem(10px) rem(26px);
      }

      .label {
        display: flex;
        flex-direction: row-reverse;

        &.laurange {flex:1;justify-content:space-between;align-items:center}

        @include mq($until: MD) {
          flex-direction: column-reverse;
        }

        .input {
          text-align: center;

          @include mq($until: MD) {
            text-align: left;
          }

        }

        &.radio, &.checkbox {
          flex-direction: row;
        }

        h3 {
          margin: 0;
          color: color(grey-dark);
          font-size: rem(16px);
          font-weight: 600;

          @include mq($until: MD) {
            font-size: rem(14px);
          }
        }
        .body {
          p {
            font-size: rem(14px);
            margin: 0;

            &:first-child {
              margin-top: rem(5px);
            }

            @include mq($until: MD) {
              font-size: rem(12px);
              line-height: rem(18px);
            }
          }
        }
      }

      .img {
        position: relative;
        margin-right: rem(18px);
        cursor: pointer;

        .loupe {
          position: absolute;
          right: 0;
          bottom: 0;
          height: rem(24px);
          width: rem(24px);
          background-image:url("data:image/svg+xml,%3Csvg width='14px' height='15px' viewBox='0 0 14 15' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3ELoupe%3C/title%3E %3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Header-Desktop' transform='translate(-883.000000, -20.000000)' fill='%239B9B9B'%3E %3Cg transform='translate(-3.000000, 0.000000)' id='Group-14'%3E %3Cg transform='translate(184.000000, 8.000000)'%3E %3Cg id='Group-2' transform='translate(689.000000, 0.000000)'%3E %3Cpath d='M26.8085608,24.8632816 C26.9361648,24.9908856 26.9999666,25.1458328 26.9999666,25.3281242 C26.9999666,25.5104156 26.9361648,25.6653629 26.8085608,25.7929669 L26.0429377,26.55859 C25.9153337,26.686194 25.7603864,26.7499958 25.578095,26.7499958 C25.3958036,26.7499958 25.2408564,26.686194 25.1132524,26.55859 L22.3788839,23.8242216 C22.2512799,23.6966176 22.1874781,23.5416703 22.1874781,23.3593789 L22.1874781,22.92188 C21.1666473,23.7239612 19.9999833,24.1250021 18.6874864,24.1250021 C17.6484264,24.1250021 16.6959549,23.8697945 15.8300714,23.3593789 C14.9641879,22.8489633 14.2760388,22.1608142 13.7656232,21.2949307 C13.2552076,20.4290472 13,19.4765757 13,18.4375156 C13,17.3984556 13.2552076,16.4459841 13.7656232,15.5801006 C14.2760388,14.7142171 14.9641879,14.026068 15.8300714,13.5156524 C16.6959549,13.0052368 17.6484264,12.7500292 18.6874864,12.7500292 C19.7265465,12.7500292 20.679018,13.0052368 21.5449015,13.5156524 C22.410785,14.026068 23.0989341,14.7142171 23.6093497,15.5801006 C24.1197653,16.4459841 24.3749729,17.3984556 24.3749729,18.4375156 C24.3749729,19.7500125 23.973932,20.9166765 23.1718507,21.9375073 L23.6093497,21.9375073 C23.7916411,21.9375073 23.9465883,22.0013091 24.0741923,22.1289131 L26.8085608,24.8632816 Z M18.6874864,21.9375073 C19.3255056,21.9375073 19.9133948,21.7825596 20.4511541,21.4726647 C20.9889134,21.1627697 21.4127405,20.7389426 21.7226355,20.2011833 C22.0325304,19.663424 22.1874781,19.0755348 22.1874781,18.4375156 C22.1874781,17.7994965 22.0325304,17.2116072 21.7226355,16.673848 C21.4127405,16.1360887 20.9889134,15.7122616 20.4511541,15.4023666 C19.9133948,15.0924717 19.3255056,14.937524 18.6874864,14.937524 C18.0494673,14.937524 17.461578,15.0924717 16.9238188,15.4023666 C16.3860595,15.7122616 15.9622324,16.1360887 15.6523374,16.673848 C15.3424425,17.2116072 15.1874948,17.7994965 15.1874948,18.4375156 C15.1874948,19.0755348 15.3424425,19.663424 15.6523374,20.2011833 C15.9622324,20.7389426 16.3860595,21.1627697 16.9238188,21.4726647 C17.461578,21.7825596 18.0494673,21.9375073 18.6874864,21.9375073 Z' id='Loupe'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E");
          background-repeat: no-repeat;
        }

        img {
          max-height: rem(140px);

          @include mq($until: MD) {
            max-height: rem(70px);
          }
        }
      }
    }
  }

</style>
